import { CHECK_DEPOSIT_STATUS } from '#client/constants/transaction';

import { RESUBMIT_ACTIONS } from '../constants/actions';
import { REJECT_REASON_LIST } from '../constants/reasons';
import { RESUBMIT_STEPS } from '../constants/steps';

export const initState = () => {
  const depositInitData = {
    title: 'Check deposit',
    currentFormStep: RESUBMIT_STEPS.INIT,
    checkId: null,
    loading: false,
    // data from graphql
    reason: null,
    status: null,
    // return from unit when resubmit
    unitReason: null,
    unitStatus: null,
    amount: 0,
    frontImage: null,
    backImage: null,
    idempotencyKey: null,
    validFrontImage: true,
    frontImageErrorMessage: null,
    validBackImage: true,
    backImageErrorMessage: null,
    validAmount: true,
    amountErrorMessage: null
  };

  return depositInitData;
};

export const createDataByReason = (reason) => {
  switch (reason) {
    case REJECT_REASON_LIST.UPDATE_CHECK_AMOUNT:
      return {
        validFrontImage: true,
        validBackImage: true,
        validAmount: false,
        amountErrorMessage: 'Ensure this matches the check amount.'
      };
    case REJECT_REASON_LIST.UPLOAD_FRONT_SIDE_IMAGE:
      return {
        validFrontImage: false,
        validBackImage: true,
        validAmount: true,
        frontImageErrorMessage:
          "Ensure the check owner's signature is clearly written on the front of the check."
      };
    case REJECT_REASON_LIST.UPLOAD_BACK_SIDE_IMAGE:
      return {
        validFrontImage: true,
        validBackImage: false,
        validAmount: true,
        backImageErrorMessage:
          'Ensure your signature endorsement is clearly written on the back of the check.'
      };
    case REJECT_REASON_LIST.UPLOAD_BACK_SIDE_IMAGE_ONLY_MOBILE:
      return {
        validFrontImage: true,
        validBackImage: false,
        validAmount: true,
        backImageErrorMessage:
          'Ensure "For Mobile Deposit Only" is clearly written under your signature on the back of the check.'
      };
    default:
      return {
        validFrontImage: true,
        validBackImage: true,
        validAmount: true
      };
  }
};

const createDataByReasonAndStatus = (reason, status) => {
  switch (status) {
    case CHECK_DEPOSIT_STATUS.AWAITING_FRONT_IMAGE:
      return {
        validFrontImage: false,
        validBackImage: true,
        validAmount: true
      };
    case CHECK_DEPOSIT_STATUS.AWAITING_BACK_IMAGE:
      return {
        validFrontImage: true,
        validBackImage: false,
        validAmount: true
      };
    case CHECK_DEPOSIT_STATUS.AWAITING_IMAGES:
      return {
        validFrontImage: false,
        validBackImage: false,
        validAmount: true
      };
    case CHECK_DEPOSIT_STATUS.AWAITING_CUSTOMER_CONFIRMATION:
      return createDataByReason(reason);
    default:
      return {
        validFrontImage: true,
        validBackImage: true,
        validAmount: true
      };
  }
};

export const resubmitReducer = (state, action) => {
  switch (action.type) {
    case RESUBMIT_ACTIONS.GO_TO_REASON:
      return {
        ...state,
        ...action.payload,
        currentFormStep: RESUBMIT_STEPS.REASON
      };

    case RESUBMIT_ACTIONS.START_LOADING:
      return {
        ...state,
        ...action.payload,
        loading: true
      };

    case RESUBMIT_ACTIONS.STOP_LOADING:
      return {
        ...state,
        ...action.payload,
        loading: false
      };

    case RESUBMIT_ACTIONS.GO_TO_RESUBMIT:
      return {
        ...state,
        ...createDataByReasonAndStatus(state.reason, state.status),
        currentFormStep: RESUBMIT_STEPS.RESUBMIT
      };

    case RESUBMIT_ACTIONS.UPDATE_UNIT_STATUS_AND_REASON:
      return {
        ...state,
        unitReason: action.payload.unitReason,
        unitStatus: action.payload.unitStatus
      };

    case RESUBMIT_ACTIONS.GO_TO_OVERVIEW:
      return {
        ...state,
        currentFormStep: RESUBMIT_STEPS.OVERVIEW,
        ...action.payload
      };

    default:
      return state;
  }
};
